// rm-lyrics-display.js — scrolling bilingual lyric strip.
//
// Mirrors `Assets/_App/UI/Components/LyricsDisplay.cs`. Renders all lyric
// lines, highlights the active one, and auto-scrolls it into view. STUB —
// Brief 001 fills this in.

import { RMComponent } from "../core/component.js";
import { html } from "../core/html.js";

export class RMLyricsDisplay extends RMComponent {
  static props = ["lines", "activeIndex"];
  /** @type {import("../types").LyricLine[] | null} */ lines = null;
  /** @type {number | null} */ activeIndex = null;

  static styles = `
    :host { display: block; max-height: 50vh; overflow: auto; }
    .line {
      padding: 0.6rem 0.75rem;
      opacity: 0.4;
      border-left: 3px solid transparent;
      border-radius: 0.25rem;
      transition: opacity 150ms ease, background 150ms ease, border-color 150ms ease;
    }
    .line.active {
      opacity: 1;
      background: rgba(255, 180, 84, 0.14);
      border-left-color: var(--rm-accent);
    }
    .line.active .zh { color: var(--rm-accent); font-weight: 600; }
    .line.active .en { color: var(--rm-fg); }
    .zh { font-size: 1.15rem; }
    .en { color: var(--rm-muted); font-size: 0.9rem; margin-top: 0.15rem; }
  `;

  render() {
    if (!Array.isArray(this.lines) || this.lines.length === 0) {
      return html`<p style="color: var(--rm-muted); padding: 0.5rem;">No lyrics for this track.</p>`;
    }
    const active = this.activeIndex ?? -1;
    return html`
      ${this.lines.map((l, i) => html`
        <div class="line ${i === active ? "active" : ""}" data-i="${i}">
          <div class="zh">${l.zh}</div>
          <div class="en">${l.en}</div>
        </div>
      `)}
    `;
  }
}
